import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[portalTableCell]',
})
export class PortalTableCellDirective {
  @Input('portalTableCell') columnKey = '';

  constructor(public template: TemplateRef<unknown>) {}
}
